import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { LeaveReviewButton, RatingSummary, ReviewCard } from "@/components/site/GoogleReviews";
import { useGoogleReviews } from "@/lib/useGoogleReviews";

// Homepage strip: rating + 3 latest Google reviews + review CTA.
export function GoogleReviewsStrip() {
  const data = useGoogleReviews();
  const reviews = (data?.reviews || []).slice(0, 3);
  return (
    <section className="bg-linen py-24 lg:py-32 px-6 md:px-10 lg:px-14" data-testid="home-google-reviews">
      <div className="max-w-[1500px] mx-auto">
        <Reveal className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12">
          <div>
            <div className="overline mb-5">Google Reviews</div>
            <h2 className="font-serif font-light text-4xl lg:text-5xl text-espresso max-w-2xl">What families in Gardner are saying.</h2>
          </div>
          <RatingSummary data={data} testid="home-google-rating" />
        </Reveal>
        {reviews.length > 0 && (
          <div className="grid md:grid-cols-3 gap-6">
            {reviews.map((r, i) => <Reveal key={r.author + i} delay={i * 80}><ReviewCard r={r} i={i} /></Reveal>)}
          </div>
        )}
        <div className="mt-12 flex flex-wrap items-center gap-6">
          <LeaveReviewButton testid="home-leave-review" />
          <Link to="/reviews" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-espresso link-underline" data-testid="home-all-reviews">
            Read more reviews <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
}
